import { useEffect } from "react";

const usePreventScroll = (shouldBlock) => {
	useEffect(() => {
		if (!shouldBlock) return;

		const preventScroll = (e) => {
			if (e.target.closest(".syndicated-flyout__primary--myPlan") || e.target.closest("#syndicated-flyout-cart")) return;
			e.preventDefault();
		};

		window.addEventListener("wheel", preventScroll, { passive: false });
		window.addEventListener("touchmove", preventScroll, { passive: false });

		return () => {
			window.removeEventListener("wheel", preventScroll);
			window.removeEventListener("touchmove", preventScroll);
		};
	}, [shouldBlock]);
};

export default usePreventScroll;
